module.exports = __webpack_public_path__ + "img/foto_aplicacoes_empilhadeiras.23ca08ce.jpg";